import SkyNetTable from 'app/shared-components/SkyNetTable'
import SkyNetDomain, {
    SidebarTab,
} from 'app/shared-components/SkyNetDomain'
import {
    TableControlTypes,
} from 'app/shared-components/TableControls'

import usePricingRoutes from 'app/SkyNetRoutes/hooks/usePricingRoutes'

import AlLeasePricingCreate from './AlLeasePricingCreate'
import AlLeasePricingOverview from './AlLeasePricingOverview'
import tableConfig from './AlLeasePricing.config'

const tableControls: TableControlTypes[] = [
    TableControlTypes.ClearFilters,
    TableControlTypes.ClearSorting,
]

const AlLeasePricing = () => {
    const {
        AlLeasePricing: AlLeasePricingRoutes,
    } = usePricingRoutes()

    const tabs: SidebarTab[] = [{
        url: AlLeasePricingRoutes.Update.route,
        label: 'Al Lease Pricing',
        Component: AlLeasePricingOverview,
    }]

    return (
        <SkyNetDomain
            actionComponents={{
                Create: AlLeasePricingCreate,
            }}
            name={tableConfig.name}
            sidebarTabs={tabs}
            defaultTab={AlLeasePricingRoutes.Update.route}
        >
            <SkyNetTable
                moduleName="pharmaleasepricing"
                tableControls={tableControls}
                tableConfig={tableConfig}
            />
        </SkyNetDomain>
    )
}

export default AlLeasePricing
